import type { UseQueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import { RolesModel } from "@/domain/model/roles";
import { QUERIES } from "@/enums/queries";
import { globalQueryClient } from "@/queries/queryClient";

import loadRoles from "./services/loadRoles";

export const useLoadRoles = (options?: UseQueryOptions<RolesModel[]>) => {
  return useQuery({
    queryKey: [QUERIES.PROFILE.ROLES.LOAD],
    queryFn: () => loadRoles(),
    staleTime: 60 * 1000,
    cacheTime: 60 * 1000,
    ...options,
  });
};

export const invalidateLoadRoles = async () => {
  await globalQueryClient.invalidateQueries({
    queryKey: [QUERIES.PROFILE.ROLES.LOAD],
    exact: false,
  });
};
